export default __webpack_public_path__ + "static/media/succesful.d5db6c1e.gif";